/* Theme css - ModernHaus-SoHo */


import { StyleSheet } from 'react-native';




export const theme = {
  PRIMARY_FONT: {
    fontFamily: 'Cy-Light',
    fontWeight: 300,
  },
  SECONDARY_FONT: {
    fontFamily: 'Cy-SemiLight',
    fontWeight: 400,
  },
  TERTIARY_FONT: {
    fontFamily: 'Cy-Regular',
    fontWeight: 600,
  },
  
  FONT_XSMALL: {
    fontSize: 10,
    lineHeight: 16,
    letterSpacing: -0.2,
    fontWeight: 500
  },
  FONT_SMALL: {
    fontSize: 14,
    lineHeight: 21,
  },
  FONT_MEDIUM: {
    fontSize: 16,
    lineHeight: 24,
  },
  FONT_LARGE: {
    fontSize: 20,
    lineHeight: 24,
  },
  FONT_XLARGE: {
    fontSize: 32,
    lineHeight: 40,
  },
  FONT_XXLARGE: {
    fontSize: 32,
    lineHeight: 40,
  },

  COLORS: {
    WHITE: "#ffffff",
    BLACK: "#000000",

    BACKGROUND_COLOR: '#FFFFFF', // background color for main containers
    BACKGROUND_COLOR_CONTRAST: '#1D1D1D',

    BACKGROUND_COLOR_SECONDARY: "#DDDED9", // secondary background color (eg: footer)
    BACKGROUND_COLOR_SECONDARY_CONTRAST: "#0C1532",

    PRIMARY_COLOR: "#FFFFFF", // primary color
    PRIMARY_TEXT_COLOR: "#1D1D1D", // primary text color

    SECONDARY_COLOR: "#BB820D", // secondary color
    SECONDARY_TEXT_COLOR: "#FFFFFF", // secondary text color

    ACCENT_COLOR: "#011E41",
    ACCENT_Text_COLOR: "#FFFFFF"
  },
};


export default StyleSheet.create({
  amount: {
    fontSize: 40,
    lineHeight: null,
  },
  billContainer: {
    paddingHorizontal: 16,
  },
  modalSubheader: {
    ...theme.PRIMARY_FONT
  },
  infoModalTitle: {
    ...theme.SECONDARY_FONT,
    paddingVertical: undefined,
  },
  billCheckoutContainer: {
    position: 'relative',
    borderTopWidth: 0.5,
    borderColor: 'rgba(0, 0, 0, 0.1)',
    paddingBottom: 24,
  },
  secondaryBtn: {
    // display: 'none'
  },
  purcharseBillText: {
    ...theme.FONT_LARGE
  },
  viewBillTotalLabel: {
    ...theme.PRIMARY_FONT
  },
  historyContainer:{
    marginBottom: 'unset',
  },



  mainContainerHeaderContainer: {
    display: 'none'
  },

  tabContainerTopBorder: {
    borderTopColor: theme.COLORS.SECONDARY_COLOR,
  },

  infoModalLoader:{
    tintColor: theme.COLORS.BLACK
  },


  infoWidgetsWidgetContainer_tab_heading: {
    gap: 0,
    paddingVertical: 32
  },

  // temp change
  infoWidgetsWidgetContainer_widget_18: {
    display: "none"
  },

  guestDetailsWidgetContainer: {
    gap: 0,
    paddingVertical: 32,
    marginTop: 0
  },
  guestDetailsImageStyle: {
    display: "none"
  },
  guestDetailsHeaderSubtitle: {
    paddingHorizontal: 24
  },
  guestDetailsButtonContainer: {
    paddingTop: 24
  },


  bannerWidgetDescription: {
    textTransform: "none"
  },

  list_itemContainer_textContainer_subtitle: {
    textTransform: "none"
  },

  bannerWidgetsWidgetContainer_widget_5: {
    flex: undefined,
    height: 112,
    paddingVertical: 0,
    marginBottom: 40,
    gap: 16,
    borderRadius: 12,
    backgroundColor: theme.COLORS.ACCENT_COLOR,
    overflow: "hidden"
  },
  bannerWidgetImageStyle_widget_5: {
    height: "100%",
    width: 128
  },
  bannerWidgetTitle_widget_5: {
    color: theme.COLORS.ACCENT_Text_COLOR
  },
  bannerWidgetDescription_widget_5: {
    color: theme.COLORS.ACCENT_Text_COLOR
  },
  bannerWidgetArrow_widget_5: {
    filter: "invert(1)",
    tintColor: theme.COLORS.ACCENT_Text_COLOR
  },

  bannerWidgetsWidgetContainer_widget_20: {
    flex: undefined,
    height: 112,
    paddingVertical: 0,
    marginBottom: 40,
    gap: 16,
    borderRadius: 12,
    backgroundColor: theme.COLORS.ACCENT_COLOR,
    overflow: "hidden"
  },
  bannerWidgetImageStyle_widget_20: {
    height: "100%",
    width: 128
  },
  bannerWidgetTitle_widget_20: {
    color: theme.COLORS.ACCENT_Text_COLOR
  },
  bannerWidgetDescription_widget_20: {
    color: theme.COLORS.ACCENT_Text_COLOR
  },
  bannerWidgetArrow_widget_20: {
    filter: "invert(1)",
    tintColor: theme.COLORS.ACCENT_Text_COLOR
  },



  bannerWidgetsWidgetContainer_dine_widget: {
    paddingVertical: 24,
  },
  bannerWidgetImageStyle_dine_widget: {
    height: 128,
    width: 128
  },
  bannerWidgetTextContainer_dine_widget: {
    height: "100%",
    justifyContent:"flex-start"
  },
  bannerWidgetTitle_dine_widget: {
    fontFamily: "Cy-Regular",
    fontSize: 20,
    lineHeight: 30
  },
  bannerWidgetArrow_container_dine_widget: {
    display: "none"
  },
  
  bannerWidgetsWidgetContainer_dine_widget_reverse: {
    flexDirection: "row-reverse",
    paddingVertical: 24,
  },
  bannerWidgetImageStyle_dine_widget_reverse: {
    height: 128,
    width: 128
  },
  bannerWidgetTextContainer_dine_widget_reverse: {
    height: "100%",
    justifyContent:"flex-start"
  },
  bannerWidgetTitle_dine_widget_reverse: {
    fontFamily: "Cy-Regular",
    fontSize: 20,
    lineHeight: 30
  },
  bannerWidgetArrow_container_dine_widget_reverse: {
    display: "none"
  },



  mainContainerHeaderTitleContainer: {
    display: "none"
  },


  checkInSuccessHeaderTitle: {
    fontFamily: [theme.TERTIARY_FONT.fontFamily, theme.PRIMARY_FONT.fontFamily],
    fontSize: 24,
    lineHeight: 36,
  },
  checkInSuccessHeaderSubTitle: {
    fontFamily: [theme.TERTIARY_FONT.fontFamily, theme.SECONDARY_FONT.fontFamily],
    fontSize: 12,
    lineHeight: 16,
    width: 243
  },

});
